<template>
  <!-- https://stackoverflow.com/questions/61444870/maximum-call-stack-size-exceeded-vuetify -->
  <v-dialog
    v-model="dialog"
    max-width="300"
    :retain-focus="false"
    persistent
    hide-overlay
  >
    <v-card class="navy pa-4" v-if="calciatore_id">
      <div
        class="navy white--text pt-2 px-2 d-flex align-center font-hemi-head"
      >
        <span style="font-size: 18px">Scegli slot per...</span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <calciatore
        class="mt-4"
        :id="calciatore_id"
        :cal="calciatoreComprato"
        borderAsRuolo
        hideEditRemove
        small
      ></calciatore>

      <div class="pa-4 white--text text-center">
        <div>
          Hai acquistato {{ nomeCalciatore }} ma non era tra i
          <span class="">"pianificati"</span>.
        </div>
        <div>
          Scegli in quale slot inserirlo tra quelli ancora liberi qui sotto:
        </div>
      </div>
      <div>
        <div
          v-if="!areSlotsEnough"
          class="pa-4 navy darken-3 error--text text-center"
        >
          <v-icon class="error--text">warning</v-icon>
          Attenzione! Non ci sono slot disponibili per
          {{ nomeCalciatore }} perchè hai acquistato più
          {{ ruolo_plurale }} rispetto a quelli pianificati: aumenta il numero
          di {{ ruolo_plurale }} pianificati nelle impostazioni della
          pianificazione<v-btn
            x-small
            icon
            outlined
            class="ml-1 error--text"
            @click="promptDialogPlanSettings"
            ><v-icon x-small class="error--text">settings</v-icon>
          </v-btn>
          <!-- ho commentato perchè dopo aver aggiornato non scompare -->
          <!-- <div class="pt-4">
            <v-btn class="error" @click="promptDialogPlanSettings"
              >Vai a 'Imposta Pianificazione'</v-btn
            >
          </div> -->
        </div>
        <v-list
          v-else
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller"
        >
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
            onlyAssociaSlot
            :overrideAssociaClick="associaSlot"
          ></asta-slot>
        </v-list>
      </div>
      <!-- <div v-if="is_mobile" class="pa-4 text-center">
        <v-btn depressed class="orange white--text" @click="showPlan">
          Apri Pianificazione
        </v-btn>
      </div> -->
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import db from "../../js/db";
import AstaSlot from "../AstaSlot";
import Calciatore from "../common/Calciatore";

export default {
  name: "dialog-associa-slot",
  mixins: [mixins],
  components: { AstaSlot, Calciatore },
  mounted() {
    console.log("--> DialogAssociaSlot mounted.");
    db.on("DialogAssociaSlot", this.show);
  },
  destroyed() {
    console.log("<-- DialogAssociaSlot destroyed.");
    db.off("DialogAssociaSlot", this.show);
  },
  data() {
    return {
      dialog: false,
      calciatore_id: null,
      processing: false,
    };
  },
  props: {},
  methods: {
    dismiss() {
      this.dialog = false;
      this.calciatore_id = null;
    },
    show(calciatore_id) {
      this.calciatore_id = calciatore_id;
      this.dialog = true;
    },
    showPlan() {
      this.dismiss();
      if (this.is_mobile) {
        db.emit("showDialogPlan");
      }
    },
    promptDialogPlanSettings() {
      db.emit("DialogPlanSettings");
    },
    associaSlot(ruolo_abc, slot) {
      const current = (this.myPlan[ruolo_abc] || {})[slot];
      if (!current || current.associato) return;
      db.setPlanAssociato(ruolo_abc, slot, this.calciatore_id);
      this.dismiss();
    },
  },
  computed: {
    nomeCalciatore() {
      if (this.calciatore_id) {
        return this.calciatori[this.calciatore_id]?.calciatore;
      }
      return null;
    },
    ruolo_abc() {
      if (this.ruolo_id) {
        return _.invert(Constants.RUOLO)[this.ruolo_id];
      }
      return null;
    },
    ruolo_id() {
      if (this.calciatore_id) {
        return this.calciatori[this.calciatore_id]?.ID_Ruolo;
      }
      return null;
    },
    ruolo_plurale() {
      if (this.ruolo_id) {
        return Constants.RUOLI_NEW[this.ruolo_id].plurale.toLowerCase();
      }
      return "";
    },
    calciatoreComprato() {
      if (this.calciatore_id) {
        return this.my_squadra.calciatori[this.calciatore_id];
      }
      return null;
    },
    areSlotsEnough() {
      return Object.values(this.myPlan[this.ruolo_abc] || {}).some(
        slot => !slot.associato
      );
    },
    ...Vuex.mapGetters(["myPlan"]),
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.link {
  text-decoration: underline;
  cursor: pointer;
}

.calciatore {
  margin: 0;
}
</style>
